import * as React from 'react';
import { Flex } from '@westhechiang/flex';
import { Box } from '@westhechiang/box';
import { Text } from '@westhechiang/text';
import { RoundedBox } from '../../../../../../../../RoundedBox';
import { RoundedImg } from '../../../../../../../../RoundedImg';
import { PurpleHeading } from '../../../../../../../../Headings/PurpleHeading/PurpleHeading';
import { ShowModalButton } from '../../../../../../../../Modal/ShowModalButton';
import { PinkHeading } from '../../../../../../../../Headings/PinkHeading';

interface HomePageCTAProps {
  image?: {
    childImageSharp: {
      fluid: {
        aspectRatio: number;
        base64: string;
        sizes: string;
        src: string;
        srcSet: string;
      };
    };
  };
}

export const HomePageCTA = ({ image }: HomePageCTAProps) => {
  return (
    <Flex
      width={1}
      flexDirection="column"
      alignItems={['center', 'center', 'flex-start']}
      position={['relative', 'relative', 'relative']}
      zIndex={4}
      mb={[0, 4, 0]}
      py={[0, 100, 0]}
    >
      <Flex
        px={3}
        flexDirection="column"
        alignItems={['center']}
        width={['100%']}
        ml={[0, 3, 0]}
      >
        {/* Logo for mobile only */}
        <Box pt={4} display={['block', 'none']}>
          <PurpleHeading fontFamily="logo" fontSize={[12]} my={2}>
            Doja
          </PurpleHeading>
        </Box>

        <Flex width={['100%']} flexDirection="column">
          <Flex
            pt={[20, 150, 200]}
            mt={5}
            pr={[0, 3, 352]}
            px={[3, 3, 0]}
            pb={[0, 0, 60]}
            flexDirection="column"
            alignItems="center"
            position="relative"
            zIndex={1}
          >
            <PinkHeading
              width={[1, 1, 1]}
              textAlign={['center']}
              fontSize={[8, 8, 10]}
              lineHeight={4}
              fontFamily="logo"
              color="purple"
              pb={3}
            >
              Human Centric Research and strategy to inform your business &
              engage your audience
            </PinkHeading>
            <ShowModalButton width={[1, 350]}>Enter the Doja</ShowModalButton>
          </Flex>
        </Flex>
      </Flex>

      {/* Mobile Image */}
      {image && (
        <RoundedBox
          width={[1]}
          mt={[5]}
          pl={[3]}
          mx={[0]}
          height={['auto']}
          display={['block', 'none']}
        >
          <RoundedImg
            height={300}
            fluid={image.childImageSharp.fluid}
            borderBottomLeftRadius="25px"
            borderTopLeftRadius="25px"
          />
        </RoundedBox>
      )}
    </Flex>
  );
};
